import { html, TemplateResult } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';

export interface OfferPanelTemplateOptions {
    variant?: 'fixed' | 'calendar';
    active?: boolean;
    identifier: string;
    lang: string;
    brand: string;
    currency: string;
    tenant: string;
    componentTitle: string;
    fallbackPrice: string;
    durationString: string;
    roundtripTypes: string;
    roundtripId: string;
    roundtripKey: string;
    phoneNumber: string;
    bookingDayOffset: number;
    showOperator: boolean;
    /** OpenAPI `roundtripOffer.startAndEndPoint` → offer panel `start-end-destination` (route line). */
    startAndEndPoint: string;
    startPoint: string;
    languages: string;
    groupSize: string;
    bestTravelTime: string;
    bestOffer: Record<string, unknown> | null;
    additionalTrackingData: Record<string, unknown>;
    facetAudience: string;
    facetStyle: string;
    facetMotive: string;
}

export const renderOfferPanel = (options: OfferPanelTemplateOptions): TemplateResult => {
    return html`
        <der-tm-roundtrip-offer-panel
            variant=${options.variant ?? ''}
            ?active=${options.active ?? true}
            identifier=${options.identifier}
            lang=${options.lang}
            brand=${options.brand}
            currency=${options.currency}
            tenant=${options.tenant}
            component-title=${options.componentTitle}
            fallback-price=${options.fallbackPrice}
            duration-string=${options.durationString}
            roundtrip-types=${options.roundtripTypes}
            roundtrip-id=${options.roundtripId}
            roundtrip-key=${options.roundtripKey}
            phone-number=${options.phoneNumber}
            booking-day-offset=${options.bookingDayOffset}
            ?show-operator=${options.showOperator}
            start-end-destination=${options.startAndEndPoint}
            start-point=${options.startPoint}
            languages=${options.languages}
            group-size=${options.groupSize}
            best-travel-time=${options.bestTravelTime}
            facet_audience=${ifDefined(options.facetAudience)}
            facet_style=${ifDefined(options.facetStyle)}
            facet_motive=${ifDefined(options.facetMotive)}
            .bestOffer=${options.bestOffer}
            .additionalTrackingData=${options.additionalTrackingData}
        ></der-tm-roundtrip-offer-panel>
    `;
};
